<template>
  <section>
    <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

    <b-field horizontal label="Авторизация">
      <b-select name="authmethod" expanded v-model="authMethod">
        <option v-for="(title, key) in authMethods()"

                :value="key"
                :selected="key === authMethod"
                :key="key"
        >
          {{ title }}
        </option>
      </b-select>
      <b-select name="authmethod" expanded v-model="whatsappAuthAccount" v-if="authMethod === 'whatsapp'">
        <option v-for="(title, key) in whatsappAccounts"

                :value="key"
                :selected="key === whatsappAuthAccount"
                :key="key"
        >
          {{ title }}
        </option>
      </b-select>
    </b-field>

    <b-field horizontal label="Текст с кодом авторизации">
      <b-input name="subject" expanded v-model="authMessage"></b-input>
    </b-field>
    <section>
      <div class="container">
        <p>Подстановка кода - работает по аналогии с текстом уведомления</p>
        <p><b>{code}</b> - для кода</p>
      </div>
    </section>

    <br/>

    <b-field horizontal label="Уведомления">
      <b-select name="authmethod" expanded v-model="notificationMethod">
        <option v-for="(title, key) in authMethods()"

                :value="key"
                :selected="key === notificationMethod"
                :key="key"
        >
          {{ title }}
        </option>
      </b-select>
      <b-select name="authmethod" expanded v-model="whatsappNotificationAccount" v-if="notificationMethod === 'whatsapp'">

        <option v-for="(title, key) in whatsappAccounts"

                :value="key"
                :selected="key === whatsappNotificationAccount"
                :key="key"
        >
          {{ title }}
        </option>
      </b-select>
    </b-field>

    <b-field horizontal label="Отключить уведомления для следующих категорий">
      <b-taginput
          v-model="customerCategoriesWithoutNotifications"
          :data="filteredCustomerCategories"
          autocomplete
          :open-on-focus="true"
          icon="label"
          placeholder="Добавить категорию"
          @typing="getFilteredTags"
          @add="updateAllowedTags"
          @remove="updateAllowedTags"
      >
      </b-taginput>
    </b-field>

    <b-field horizontal>
      <p class="control">
        <b-button label="Обновить" type="is-primary" @click="update()" :disabled="loading"/>
      </p>
    </b-field>
  </section>
</template>

<script>
import customerCategoryRepository from '@/repository/customerCategoryRepository';
import settingsRepository from '../../repository/settingsRepository';
import whatsappAccountsRepository from '../../repository/whatsappAccountsRepository';

export default {
  data () {
    return {
      loading: false,
      authMethod: null,
      authMessage: null,
      whatsappAuthAccount: null,
      whatsappAccounts: {},
      notificationMethod: null,
      whatsappNotificationAccount: null,
      customerCategoriesWithoutNotifications: [],
      customerCategories: [],
      customerCategoriesArray: [],
      filteredCustomerCategories: [],
    };
  },
  methods: {
    fetchData () {
      this.loading = true;

      Promise.all([
        whatsappAccountsRepository.list()
        .then(({data}) => {
          this.whatsappAccounts = data;
        }),
        customerCategoryRepository.all()
        .then(({data}) => {
          this.customerCategories = data;
          this.customerCategoriesArray = data.map((option) => option.title);
          this.filteredCustomerCategories = data.map((option) => option.title);

        }),
      ])
      .then(() => {
        settingsRepository.get()
        .then(({data}) => {
          this.authMethod = data?.authMethod;
          this.whatsappAuthAccount = data?.whatsappAuthAccount;
          this.notificationMethod = data?.notificationMethod;
          this.whatsappNotificationAccount = data?.whatsappNotificationAccount;
          this.authMessage = data?.authMessage;

          this.customerCategoriesWithoutNotifications = this.customerCategories
          .filter((item) => (data?.customerCategoriesWithoutNotifications ?? []).some(x => x == item.id))
          .map((item) => item.title);

          this.updateAllowedTags();
        });
      })
      .finally(() => {
        this.loading = false;
      });
    },
    update () {
      this.loading = true;

      let customerCategoriesIds = this.customerCategories
      .filter(item => this.customerCategoriesWithoutNotifications.includes(item.title))
      .map(item => item.id);

      settingsRepository.update(this.authMethod, this.whatsappAuthAccount, this.notificationMethod, this.whatsappNotificationAccount, customerCategoriesIds, this.authMessage)
      .then(() => this.$buefy.toast.open('Настройки обновлены'))
      .catch(() => this.$buefy.toast.open({
        message: 'Ошибка при обновлении настроек',
        type: 'is-danger',
      }))
      .finally(() => {
        this.loading = false;
      });
    },
    authMethods () {
      return {
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        none: 'Отсутствует',
      };
    },
    getFilteredTags (text) {
      if (text == null) {
        return;
      }

      this.updateAllowedTags();

      this.filteredCustomerCategories = this.filteredCustomerCategories.filter((option) => {
        return (
            option
            .toString()
            .toLowerCase()
            .indexOf(text.toString().toLowerCase()) >= 0
        );
      });
    },
    updateAllowedTags () {
      this.filteredCustomerCategories = this.customerCategoriesArray
      .filter((e) => this.customerCategoriesWithoutNotifications.indexOf(e) === -1);
    },
  },
  mounted () {
    this.fetchData();
  },
};
</script>

<style scoped>

</style>
